<template>
    <div>
      <tse-login></tse-login>
      <el-button type="primary">主要按钮</el-button>
    </div>
</template>

<script>
  import create from '../utils/create-basic'
    export default create(
      {
        name: "page"
      }
    )
</script>

<style scoped>

</style>
